import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CATEGORIES = [
    {
        id: 'price', icon: '💸', title: 'Prix / Budget',
        cards: [
            { id: 1, title: '"C\'est trop cher"', punchline: "Si vous trouvez qu'un expert coûte cher, attendez de voir ce que vous coûtera un amateur.", detail: "Rappeler le coût d'un site non visible (0€ rapporté)." },
            { id: 2, title: '"J\'ai pas le budget"', punchline: "C'est justement pour ça qu'il faut investir. Un site n'est pas une dépense, c'est une machine à cash.", detail: "Proposer le paiement en 3x ou 10x." },
            { id: 3, title: '"Moins cher ailleurs"', punchline: "On ne compare pas une Twingo et une Tesla. Vous voulez rouler ou piloter ?", detail: "Comparer les fonctionnalités (SEO, Vitesse, Accompagnement)." }
        ]
    },
    {
        id: 'time', icon: '⏳', title: 'Temps / Délai',
        cards: [
            { id: 4, title: '"J\'ai pas le temps"', punchline: "Je m'occupe de tout. Vous validez juste les designs. C'est 1h de votre temps, pas plus.", detail: "Insister sur la délégation totale (Clé en main)." },
            { id: 5, title: '"C\'est pas urgent"', punchline: "Pendant que vous attendez, vos concurrents vous prennent 80% des clients Google.", detail: "Montrer le Diagnostic Flash (Urgence)." }
        ]
    },
    {
        id: 'trust', icon: '🤝', title: 'Confiance / Risque',
        cards: [
            { id: 6, title: '"Ça marche vraiment ?"', punchline: "Regardez les stats de [Client Voisin]. +30% de CA en 3 mois. On fait pareil pour vous ?", detail: "Montrer le Dashboard Démo ou la Carte Locale." },
            { id: 7, title: '"Je suis nul en informatique"', punchline: "Notre outil est plus simple que WhatsApp. Si vous savez envoyer un SMS, vous savez gérer votre site.", detail: "Montrer l'interface admin simplifiée." }
        ]
    }
];

export default function CommercialBattlecardsPage() {
    const navigate = useNavigate();
    const [selectedCat, setSelectedCat] = useState(null);

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#1e293b', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>

            {/* Header */}
            <div style={{ padding: '20px 40px', background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', gap: 20 }}>
                <button onClick={selectedCat ? () => setSelectedCat(null) : () => navigate('/commercial/launchpad')} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '1.5rem', cursor: 'pointer' }}>←</button>
                <div style={{ fontSize: '1.5rem', fontWeight: 800 }}>⚔️ Dojo de Vente</div>
            </div>

            <div style={{ flex: 1, padding: 40, overflowY: 'auto' }}>

                {!selectedCat ? (
                    // CATEGORY GRID
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 30, maxWidth: 1000, margin: '0 auto' }}>
                        {CATEGORIES.map(cat => (
                            <div key={cat.id} onClick={() => setSelectedCat(cat)} style={{
                                background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                                border: '1px solid rgba(255,255,255,0.1)', borderRadius: 24, padding: 40,
                                cursor: 'pointer', textAlign: 'center', transition: 'transform 0.2s', boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                            }} onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
                                <div style={{ fontSize: '4rem', marginBottom: 20 }}>{cat.icon}</div>
                                <h2 style={{ fontSize: '2rem', fontWeight: 700, margin: 0 }}>{cat.title}</h2>
                                <p style={{ opacity: 0.6, marginTop: 10 }}>{cat.cards.length} arguments</p>
                            </div>
                        ))}
                    </div>
                ) : (
                    // CARDS VIEW
                    <div style={{ maxWidth: 800, margin: '0 auto' }}>
                        <h2 style={{ fontSize: '2rem', marginBottom: 30, borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: 10 }}>{selectedCat.icon} {selectedCat.title}</h2>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                            {selectedCat.cards.map(card => (
                                <div key={card.id} style={{ background: 'white', color: '#1e293b', borderRadius: 16, overflow: 'hidden', animation: 'fadeIn 0.3s ease-out' }}>
                                    <div style={{ padding: '20px 30px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', fontWeight: 700, fontSize: '1.1rem', color: '#ef4444' }}>
                                        🤬 {card.title}
                                    </div>
                                    <div style={{ padding: '30px', position: 'relative' }}>
                                        <div style={{ fontSize: '1.4rem', fontWeight: 800, marginBottom: 15, lineHeight: 1.4 }}>
                                            "{card.punchline}"
                                        </div>
                                        <div style={{ fontSize: '0.9rem', color: '#64748b', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: 10 }}>
                                            💡 Conseil : {card.detail}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }`}</style>
        </div>
    );
}
